import qs from "query-string";
const parsed = qs.parse(location.search, { parseBooleans: true });
const isProd = process.env.NODE_ENV === "production";

export const concertId = parsed.cid;
export const key = parsed.key;

export const debug = isProd ? false : parsed.debug;
export const cheat = isProd ? false : parsed.cheat;
export const noCache = isProd ? false : parsed.noCache;
